import React, { useState } from 'react';
import styled from 'styled-components';
import { FaBars, FaTimes } from 'react-icons/fa';

const HeaderContainer = styled.header`
  background: rgba(10, 26, 31, 0.95);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding: 1rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  width: 100%;
  height: 80px;
  top: 0;
  left: 0;
  z-index: 1000;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  
  @media (max-width: 768px) {
    padding: 0.8rem 1.5rem;
    height: 70px;
  }
`;

const Logo = styled.div`
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 8px;
  padding: 8px 12px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  
  img {
    width: 250px;
    height: 250px;
    object-fit: contain;
    margin-right: 1rem;
    
    @media (max-width: 768px) {
      width: 200px;
      height: 200px;
    }
  }
  
`;

const Nav = styled.nav`
  @media (max-width: 768px) {
    position: fixed;
    top: 0;
    right: ${props => (props.$isOpen ? '0' : '-100%')};
    width: 70%;
    height: 100vh;
    background-color: #0a1a1f;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    transition: right 0.3s ease-in-out;
    box-shadow: ${props => (props.$isOpen ? '-5px 0 15px rgba(0, 0, 0, 0.3)' : 'none')};
    z-index: 1001;
  }
  
  ul {
    display: flex;
    list-style: none;
    margin: 0;
    padding: 0;
    
    @media (max-width: 768px) {
      flex-direction: column;
      align-items: center;
    }
  }
  
  li {
    margin-left: 2rem;
    
    @media (max-width: 768px) {
      margin: 1.5rem 0;
      margin-left: 0;
    }
  }
  
  a {
    color: white;
    text-decoration: none;
    font-size: 1rem;
    
    @media (max-width: 768px) {
      font-size: 1.2rem;
    }
    transition: color 0.3s ease, transform 0.2s ease;
    
    &:hover {
      color: #00e1c7;
      transform: translateY(-2px);
    }
  }
`;

const MobileMenuButton = styled.button`
  display: none;
  background: none;
  border: none;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
  z-index: 1002;
  
  @media (max-width: 768px) {
    display: block;
  }
  
  &:focus {
    outline: none;
  }
`;

const Overlay = styled.div`
  display: none;
  
  @media (max-width: 768px) {
    display: ${props => (props.$isOpen ? 'block' : 'none')};
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 1000;
  }
`;

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  
  const closeMenu = () => {
    setIsMenuOpen(false);
  };
  
  return (
    <HeaderContainer>
      <Logo>
        <img src="/images/applogo.png" alt="ParkGanga Logo" />
      </Logo>
      
      <MobileMenuButton onClick={toggleMenu}>
        {isMenuOpen ? <FaTimes /> : <FaBars />}
      </MobileMenuButton>
      
      <Overlay $isOpen={isMenuOpen} onClick={closeMenu} />
      
      <Nav $isOpen={isMenuOpen}>
        <ul>
          <li><a href="#home" onClick={closeMenu}>HOME</a></li>
          <li><a href="#features" onClick={closeMenu}>FEATURES</a></li>
          <li><a href="https://play.google.com/store/apps/details?id=com.empiinnovationhub.smooth" target="_blank" onClick={closeMenu}>DOWNLOAD APP</a></li>
        </ul>
      </Nav>
    </HeaderContainer>
  );
};

export default Header;